// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// const blogs = [
//   {
//     id: 1,
//     slug: 'physiotherapy-knee-pain',
//     category: 'Orthopedic',
//     title: 'Knee Pain Without Surgery: How Physiotherapy Restores Function',
//     excerpt: 'Knee pain is the second most common cause of chronic pain globally. Discover how targeted physiotherapy exercises can restore strength, reduce pain, and delay or avoid surgery.',
//     author: 'Docmize Health Desk',
//     date: '8 Apr 2024',
//     readTime: '6 min read',
//     image: '/images/17.png',
//     featured: true,
//   },
//   {
//     id: 2,
//     slug: 'dental-implants-guide',
//     category: 'Dental',
//     title: 'Dental Implants: Everything You Need to Know Before Getting One',
//     excerpt: 'From candidacy and procedure to recovery and long-term care — a complete patient guide to dental implants written in plain language.',
//     author: 'Docmize Health Desk',
//     date: '28 Mar 2024',
//     readTime: '8 min read',
//     image: 'https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=700&q=80',
//     featured: false,
//   },
//   {
//     id: 3,
//     slug: 'child-fever-when-to-see-doctor',
//     category: 'Pediatrics',
//     title: 'Child Fever: When to Wait and When to See a Doctor Immediately',
//     excerpt: 'Fever is one of the most common reasons parents rush to the doctor. This guide explains the thresholds, warning signs, and when home care is sufficient.',
//     author: 'Docmize Health Desk',
//     date: '5 Apr 2024',
//     readTime: '5 min read',
//     image: '/images/20.png',
//     featured: false,
//   },
//   {
//     id: 4,
//     slug: 'back-pain-physiotherapy',
//     category: 'Physiotherapy',
//     title: 'Chronic Back Pain: Why Physiotherapy Works Better Than Painkillers',
//     excerpt: 'Millions rely on medication to manage back pain without addressing the root cause. Here is why physiotherapy produces lasting results where pills fail.',
//     author: 'Docmize Health Desk',
//     date: '18 Mar 2024',
//     readTime: '7 min read',
//     image: '/images/12.png',
//     featured: true,
//   },
//   {
//     id: 5,
//     slug: 'nutrition-for-diabetes',
//     category: 'Nutrition',
//     title: 'What to Eat When You Have Diabetes: A Practical Nutrition Guide',
//     excerpt: 'Managing blood sugar through diet is not about deprivation — it is about understanding which foods help and which ones harm. A dietitian-backed guide.',
//     author: 'Docmize Health Desk',
//     date: '2 Apr 2024',
//     readTime: '7 min read',
//     image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=700&q=80',
//     featured: false,
//   },
//   {
//     id: 6,
//     slug: 'anxiety-therapy-options',
//     category: 'Mental Health',
//     title: 'Understanding Anxiety: Types, Triggers, and Therapy Options That Work',
//     excerpt: 'Anxiety disorders are among the most common mental health conditions, yet most people suffer without treatment. This article explains what actually helps.',
//     author: 'Docmize Health Desk',
//     date: '10 Apr 2024',
//     readTime: '8 min read',
//     image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=700&q=80',
//     featured: false,
//   },
//   {
//     id: 7,
//     slug: 'obesity-beyond-weight-loss',
//     category: 'Obesity & Diabetes',
//     title: 'Obesity Is a Disease, Not a Lifestyle Choice: What Science Actually Says',
//     excerpt: 'The medical understanding of obesity has changed dramatically. Here is the current science on causes, health consequences, and effective treatment approaches.',
//     author: 'Docmize Health Desk',
//     date: '22 Mar 2024',
//     readTime: '9 min read',
//     image: '/images/24.png',
//     featured: false,
//   },
//   {
//     id: 8,
//     slug: 'root-canal-myths',
//     category: 'Dental',
//     title: 'Root Canal Treatment: Separating Fact from Fear',
//     excerpt: 'Root canals have an undeserved reputation for being painful and scary. Modern root canal treatment is routine, comfortable, and saves teeth that would otherwise be lost.',
//     author: 'Docmize Health Desk',
//     date: '15 Mar 2024',
//     readTime: '5 min read',
//     image: '/images/26.png',
//     featured: false,
//   },
//   {
//     id: 9,
//     slug: 'physiotherapy-knee-pain',
//     category: 'Physiotherapy',
//     title: 'Knee Pain Without Surgery: How Physiotherapy Restores Function',
//     excerpt: 'Knee pain is the second most common cause of chronic pain globally. Discover how targeted physiotherapy exercises can restore strength, reduce pain, and delay or avoid surgery.',
//     author: 'Docmize Health Desk',
//     date: '8 Apr 2024',
//     readTime: '6 min read',
//     image: '/images/16.png',
//     featured: false,
//   },
//   {
//     id: 10,
//     slug: 'occupational-therapy-children',
//     category: 'Occupational Therapy',
//     title: 'Occupational Therapy for Children: Signs Your Child May Benefit',
//     excerpt: 'Many developmental delays and sensory processing challenges respond remarkably well to occupational therapy. Here are the signs parents should watch for.',
//     author: 'Docmize Health Desk',
//     date: '25 Mar 2024',
//     readTime: '6 min read',
//     image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=700&q=80',
//     featured: false,
//   },
//   {
//     id: 11,
//     slug: 'homeopathy-evidence',
//     category: 'Homeopathy',
//     title: 'Homeopathy: What Conditions It Is Used For and What Patients Report',
//     excerpt: 'A balanced look at homeopathic medicine — the conditions practitioners treat, how to find a qualified homeopath, and questions to ask before starting treatment.',
//     author: 'Docmize Health Desk',
//     date: '1 Apr 2024',
//     readTime: '5 min read',
//     image: '/images/30.png',
//     featured: false,
//   },
//   {
//     id: 12,
//     slug: 'psychotherapy-vs-psychiatry',
//     category: 'Mental Health',
//     title: 'Psychotherapy vs Psychiatry: Which Type of Mental Health Professional Do You Need?',
//     excerpt: 'Therapists, psychologists, and psychiatrists all treat mental health — but they are very different. This guide explains who does what and how to choose.',
//     author: 'Docmize Health Desk',
//     date: '19 Mar 2024',
//     readTime: '7 min read',
//     image: '/images/32.png',
//     featured: false,
//   },
// ];

// const categories = ['All', 'Dental', 'Pediatrics', 'Physiotherapy', 'Nutrition', 'Mental Health', 'Obesity & Diabetes', 'Occupational Therapy', 'Homeopathy'];

// const categoryColors = {
//   'Dental': 'bg-blue-50 text-blue-700',
//   'Pediatrics': 'bg-purple-50 text-purple-700',
//   'Physiotherapy': 'bg-orange-50 text-orange-700',
//   'Nutrition': 'bg-green-50 text-green-700',
//   'Mental Health': 'bg-indigo-50 text-indigo-700',
//   'Obesity & Diabetes': 'bg-red-50 text-red-700',
//   'Occupational Therapy': 'bg-teal-50 text-teal-700',
//   'Homeopathy': 'bg-yellow-50 text-yellow-700',
// };

// const BlogListing = () => {
//   const [selectedCategory, setSelectedCategory] = useState('All');

//   const filtered = selectedCategory === 'All'
//     ? blogs
//     : blogs.filter(b => b.category === selectedCategory);

//   const featured = blogs.filter(b => b.featured);
//   const showFeatured = selectedCategory === 'All';

//   return (
//     <div style={{ minHeight: '100vh', background: '#f8f9fb', fontFamily: 'sans-serif' }}>

//       {/* Page Header */}
//       <div style={{ background: '#19354a', padding: '52px 24px' }}>
//         <div style={{ maxWidth: 1100, margin: '0 auto', textAlign: 'center' }}>
//           <p style={{ color: '#39a5d3', fontSize: 12, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 10 }}>
//             Docmize Health Journal
//           </p>
//           <h1 style={{ color: '#fff', fontSize: 36, fontWeight: 700, lineHeight: 1.2, marginBottom: 12, maxWidth: 560, margin: '0 auto 12px' }}>
//             Health insights from verified medical professionals
//           </h1>
//           <p style={{ color: '#93b8cc', fontSize: 15, maxWidth: 480, lineHeight: 1.7, margin: '0 auto' }}>
//             Evidence-based articles across dental care, physiotherapy, mental health, pediatrics, nutrition, and more — written for patients, not professionals.
//           </p>
//         </div>
//       </div>

//       <div style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 24px 60px' }}>

//         {/* Featured Articles */}
//         {showFeatured && (
//           <div style={{ marginBottom: 52 }}>
//             <h2 style={{ fontSize: 13, fontWeight: 700, color: '#19354a', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 20 }}>
//               Featured Articles
//             </h2>
//             <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
//               {featured.map(blog => (
//                 <Link
//                   key={blog.id}
//                   to={`/blog/${blog.slug}`}
//                   style={{ textDecoration: 'none', display: 'block', borderRadius: 14, overflow: 'hidden', background: '#fff', border: '1px solid #eaecf0', transition: 'box-shadow 0.2s' }}
//                   onMouseEnter={e => e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.09)'}
//                   onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
//                 >
//                   <div style={{ height: 220, overflow: 'hidden' }}>
//                     <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
//                   </div>
//                   <div style={{ padding: '22px 24px 26px' }}>
//                     <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
//                       <span className={`text-xs font-semibold px-2.5 py-1 rounded ${categoryColors[blog.category] || 'bg-gray-100 text-gray-600'}`}>
//                         {blog.category}
//                       </span>
//                       <span style={{ fontSize: 12, color: '#9ca3af' }}>{blog.readTime}</span>
//                     </div>
//                     <h3 style={{ fontSize: 18, fontWeight: 700, color: '#19354a', lineHeight: 1.35, marginBottom: 10 }}>
//                       {blog.title}
//                     </h3>
//                     <p style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.65, marginBottom: 16 }}>
//                       {blog.excerpt}
//                     </p>
//                     <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#9ca3af', borderTop: '1px solid #f3f4f6', paddingTop: 14 }}>
//                       <span>{blog.author}</span>
//                       <span>{blog.date}</span>
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           </div>
//         )}

//         {/* Category Filter */}
//         <div style={{ marginBottom: 28 }}>
//           <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
//             {categories.map(cat => (
//               <button
//                 key={cat}
//                 onClick={() => setSelectedCategory(cat)}
//                 style={{
//                   padding: '7px 18px', borderRadius: 6, fontSize: 13, fontWeight: 500,
//                   cursor: 'pointer', border: selectedCategory === cat ? 'none' : '1px solid #e0e4ea',
//                   background: selectedCategory === cat ? '#19354a' : '#fff',
//                   color: selectedCategory === cat ? '#fff' : '#374151',
//                   fontFamily: 'inherit', transition: 'all 0.15s',
//                 }}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>
//         </div>

//         {/* Divider + Count */}
//         <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
//           <h2 style={{ fontSize: 13, fontWeight: 700, color: '#19354a', letterSpacing: 1, textTransform: 'uppercase' }}>
//             {selectedCategory === 'All' ? 'All Articles' : selectedCategory}
//           </h2>
//           <span style={{ fontSize: 12, color: '#9ca3af' }}>{filtered.length} article{filtered.length !== 1 ? 's' : ''}</span>
//         </div>

//         {/* Articles Grid */}
//         <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
//           {filtered.map(blog => (
//             <Link
//               key={blog.id}
//               to={`/blog/${blog.slug}`}
//               style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', borderRadius: 12, overflow: 'hidden', background: '#fff', border: '1px solid #eaecf0', transition: 'box-shadow 0.2s' }}
//               onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.07)'}
//               onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
//             >
//               {/* Image */}
//               <div style={{ height: 180, overflow: 'hidden', flexShrink: 0 }}>
//                 <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
//               </div>

//               {/* Content */}
//               <div style={{ padding: '18px 20px 22px', display: 'flex', flexDirection: 'column', flex: 1 }}>
//                 <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
//                   <span className={`text-xs font-semibold px-2.5 py-1 rounded ${categoryColors[blog.category] || 'bg-gray-100 text-gray-600'}`}>
//                     {blog.category}
//                   </span>
//                   <span style={{ fontSize: 11, color: '#9ca3af' }}>{blog.readTime}</span>
//                 </div>
//                 <h3 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', lineHeight: 1.4, marginBottom: 8, flex: 1 }}>
//                   {blog.title}
//                 </h3>
//                 <p style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.6, marginBottom: 14 }}>
//                   {blog.excerpt.length > 110 ? blog.excerpt.slice(0, 110) + '...' : blog.excerpt}
//                 </p>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#9ca3af', borderTop: '1px solid #f3f4f6', paddingTop: 12 }}>
//                   <span>{blog.author}</span>
//                   <span>{blog.date}</span>
//                 </div>
//               </div>
//             </Link>
//           ))}
//         </div>

//         {filtered.length === 0 && (
//           <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9ca3af' }}>
//             <p style={{ fontSize: 16, fontWeight: 600, color: '#374151', marginBottom: 8 }}>No articles in this category yet</p>
//             <p style={{ fontSize: 13 }}>Check back soon or browse all articles</p>
//           </div>
//         )}

//       </div>
//     </div>
//   );
// };

// export default BlogListing;


import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const blogs = [
  { id: 1, slug: 'physiotherapy-knee-pain', category: 'Orthopedic', title: 'Knee Pain Without Surgery: How Physiotherapy Restores Function', excerpt: 'Knee pain is the second most common cause of chronic pain globally. Discover how targeted physiotherapy exercises can restore strength, reduce pain, and delay or avoid surgery.', author: 'Docmize Health Desk', date: '8 Apr 2024', readTime: '6 min read', image: '/images/17.png', featured: true },
  { id: 2, slug: 'dental-implants-guide', category: 'Dental', title: 'Dental Implants: Everything You Need to Know Before Getting One', excerpt: 'From candidacy and procedure to recovery and long-term care — a complete patient guide to dental implants written in plain language.', author: 'Docmize Health Desk', date: '28 Mar 2024', readTime: '8 min read', image: 'https://images.unsplash.com/photo-1609840114035-3c981b782dfe?w=700&q=80', featured: false },
  { id: 3, slug: 'child-fever-when-to-see-doctor', category: 'Pediatrics', title: 'Child Fever: When to Wait and When to See a Doctor Immediately', excerpt: 'Fever is one of the most common reasons parents rush to the doctor. This guide explains the thresholds, warning signs, and when home care is sufficient.', author: 'Docmize Health Desk', date: '5 Apr 2024', readTime: '5 min read', image: '/images/20.png', featured: false },
  { id: 4, slug: 'back-pain-physiotherapy', category: 'Physiotherapy', title: 'Chronic Back Pain: Why Physiotherapy Works Better Than Painkillers', excerpt: 'Millions rely on medication to manage back pain without addressing the root cause. Here is why physiotherapy produces lasting results where pills fail.', author: 'Docmize Health Desk', date: '18 Mar 2024', readTime: '7 min read', image: '/images/12.png', featured: true },
  { id: 5, slug: 'nutrition-for-diabetes', category: 'Nutrition', title: 'What to Eat When You Have Diabetes: A Practical Nutrition Guide', excerpt: 'Managing blood sugar through diet is not about deprivation — it is about understanding which foods help and which ones harm. A dietitian-backed guide.', author: 'Docmize Health Desk', date: '2 Apr 2024', readTime: '7 min read', image: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=700&q=80', featured: false },
  { id: 6, slug: 'anxiety-therapy-options', category: 'Mental Health', title: 'Understanding Anxiety: Types, Triggers, and Therapy Options That Work', excerpt: 'Anxiety disorders are among the most common mental health conditions, yet most people suffer without treatment. This article explains what actually helps.', author: 'Docmize Health Desk', date: '10 Apr 2024', readTime: '8 min read', image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=700&q=80', featured: false },
  { id: 7, slug: 'obesity-beyond-weight-loss', category: 'Obesity & Diabetes', title: 'Obesity Is a Disease, Not a Lifestyle Choice: What Science Actually Says', excerpt: 'The medical understanding of obesity has changed dramatically. Here is the current science on causes, health consequences, and effective treatment approaches.', author: 'Docmize Health Desk', date: '22 Mar 2024', readTime: '9 min read', image: '/images/24.png', featured: false },
  { id: 8, slug: 'root-canal-myths', category: 'Dental', title: 'Root Canal Treatment: Separating Fact from Fear', excerpt: 'Root canals have an undeserved reputation for being painful and scary. Modern root canal treatment is routine, comfortable, and saves teeth that would otherwise be lost.', author: 'Docmize Health Desk', date: '15 Mar 2024', readTime: '5 min read', image: '/images/26.png', featured: false },
  { id: 9, slug: 'physiotherapy-knee-pain', category: 'Physiotherapy', title: 'Knee Pain Without Surgery: How Physiotherapy Restores Function', excerpt: 'Knee pain is the second most common cause of chronic pain globally. Discover how targeted physiotherapy exercises can restore strength, reduce pain, and delay or avoid surgery.', author: 'Docmize Health Desk', date: '8 Apr 2024', readTime: '6 min read', image: '/images/16.png', featured: false },
  { id: 10, slug: 'occupational-therapy-children', category: 'Occupational Therapy', title: 'Occupational Therapy for Children: Signs Your Child May Benefit', excerpt: 'Many developmental delays and sensory processing challenges respond remarkably well to occupational therapy. Here are the signs parents should watch for.', author: 'Docmize Health Desk', date: '25 Mar 2024', readTime: '6 min read', image: 'https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?w=700&q=80', featured: false },
  { id: 11, slug: 'homeopathy-evidence', category: 'Homeopathy', title: 'Homeopathy: What Conditions It Is Used For and What Patients Report', excerpt: 'A balanced look at homeopathic medicine — the conditions practitioners treat, how to find a qualified homeopath, and questions to ask before starting treatment.', author: 'Docmize Health Desk', date: '1 Apr 2024', readTime: '5 min read', image: '/images/30.png', featured: false },
  { id: 12, slug: 'psychotherapy-vs-psychiatry', category: 'Mental Health', title: 'Psychotherapy vs Psychiatry: Which Type of Mental Health Professional Do You Need?', excerpt: 'Therapists, psychologists, and psychiatrists all treat mental health — but they are very different. This guide explains who does what and how to choose.', author: 'Docmize Health Desk', date: '19 Mar 2024', readTime: '7 min read', image: '/images/32.png', featured: false },
];

const categories = ['All', 'Dental', 'Pediatrics', 'Physiotherapy', 'Nutrition', 'Mental Health', 'Obesity & Diabetes', 'Occupational Therapy', 'Homeopathy'];

const categoryColors = {
  'Dental': 'bg-blue-50 text-blue-700',
  'Pediatrics': 'bg-purple-50 text-purple-700',
  'Physiotherapy': 'bg-orange-50 text-orange-700',
  'Nutrition': 'bg-green-50 text-green-700',
  'Mental Health': 'bg-indigo-50 text-indigo-700',
  'Obesity & Diabetes': 'bg-red-50 text-red-700',
  'Occupational Therapy': 'bg-teal-50 text-teal-700',
  'Homeopathy': 'bg-yellow-50 text-yellow-700',
};

const mobileCSS = `
  @media (max-width: 768px) {
    .blog-hero { padding: 36px 16px !important; }
    .blog-hero h1 { font-size: 24px !important; }
    .blog-hero p { font-size: 13px !important; }
    .blog-container { padding: 24px 16px 40px !important; }
    .featured-grid { grid-template-columns: 1fr !important; gap: 16px !important; }
    .featured-img { height: 180px !important; }
    .articles-grid { grid-template-columns: 1fr !important; gap: 14px !important; }
    .category-filter { gap: 6px !important; }
    .category-filter button { padding: 6px 12px !important; font-size: 12px !important; }
    .article-img { height: 160px !important; }
  }
`;

const BlogListing = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const filtered = selectedCategory === 'All' ? blogs : blogs.filter(b => b.category === selectedCategory);
  const featured = blogs.filter(b => b.featured);
  const showFeatured = selectedCategory === 'All';

  return (
    <div style={{ minHeight: '100vh', background: '#f8f9fb', fontFamily: 'sans-serif' }}>
      <style>{mobileCSS}</style>

      {/* Page Header */}
      <div className="blog-hero" style={{ background: '#19354a', padding: '52px 24px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto', textAlign: 'center' }}>
          <p style={{ color: '#39a5d3', fontSize: 12, fontWeight: 700, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 10 }}>
            Docmize Health Journal
          </p>
          <h1 style={{ color: '#fff', fontSize: 36, fontWeight: 700, lineHeight: 1.2, marginBottom: 12, maxWidth: 560, margin: '0 auto 12px' }}>
            Health insights from verified medical professionals
          </h1>
          <p style={{ color: '#93b8cc', fontSize: 15, maxWidth: 480, lineHeight: 1.7, margin: '0 auto' }}>
            Evidence-based articles across dental care, physiotherapy, mental health, pediatrics, nutrition, and more — written for patients, not professionals.
          </p>
        </div>
      </div>

      <div className="blog-container" style={{ maxWidth: 1100, margin: '0 auto', padding: '40px 24px 60px' }}>

        {/* Featured Articles */}
        {showFeatured && (
          <div style={{ marginBottom: 52 }}>
            <h2 style={{ fontSize: 13, fontWeight: 700, color: '#19354a', letterSpacing: 1, textTransform: 'uppercase', marginBottom: 20 }}>
              Featured Articles
            </h2>
            <div className="featured-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 24 }}>
              {featured.map(blog => (
                <Link key={blog.id} to={`/blog/${blog.slug}`}
                  style={{ textDecoration: 'none', display: 'block', borderRadius: 14, overflow: 'hidden', background: '#fff', border: '1px solid #eaecf0', transition: 'box-shadow 0.2s' }}
                  onMouseEnter={e => e.currentTarget.style.boxShadow = '0 8px 32px rgba(0,0,0,0.09)'}
                  onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
                  <div className="featured-img" style={{ height: 220, overflow: 'hidden' }}>
                    <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                  </div>
                  <div style={{ padding: '22px 24px 26px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                      <span className={`text-xs font-semibold px-2.5 py-1 rounded ${categoryColors[blog.category] || 'bg-gray-100 text-gray-600'}`}>{blog.category}</span>
                      <span style={{ fontSize: 12, color: '#9ca3af' }}>{blog.readTime}</span>
                    </div>
                    <h3 style={{ fontSize: 18, fontWeight: 700, color: '#19354a', lineHeight: 1.35, marginBottom: 10 }}>{blog.title}</h3>
                    <p style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.65, marginBottom: 16 }}>{blog.excerpt}</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: '#9ca3af', borderTop: '1px solid #f3f4f6', paddingTop: 14 }}>
                      <span>{blog.author}</span>
                      <span>{blog.date}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Category Filter */}
        <div style={{ marginBottom: 28 }}>
          <div className="category-filter" style={{ display: 'flex', gap: 8, flexWrap: 'wrap', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            {categories.map(cat => (
              <button key={cat} onClick={() => setSelectedCategory(cat)}
                style={{ padding: '7px 18px', borderRadius: 6, fontSize: 13, fontWeight: 500, cursor: 'pointer', border: selectedCategory === cat ? 'none' : '1px solid #e0e4ea', background: selectedCategory === cat ? '#19354a' : '#fff', color: selectedCategory === cat ? '#fff' : '#374151', fontFamily: 'inherit', transition: 'all 0.15s', whiteSpace: 'nowrap', flexShrink: 0 }}>
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Count */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <h2 style={{ fontSize: 13, fontWeight: 700, color: '#19354a', letterSpacing: 1, textTransform: 'uppercase' }}>
            {selectedCategory === 'All' ? 'All Articles' : selectedCategory}
          </h2>
          <span style={{ fontSize: 12, color: '#9ca3af' }}>{filtered.length} article{filtered.length !== 1 ? 's' : ''}</span>
        </div>

        {/* Articles Grid */}
        <div className="articles-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 24 }}>
          {filtered.map(blog => (
            <Link key={blog.id} to={`/blog/${blog.slug}`}
              style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column', borderRadius: 12, overflow: 'hidden', background: '#fff', border: '1px solid #eaecf0', transition: 'box-shadow 0.2s' }}
              onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.07)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}>
              <div className="article-img" style={{ height: 180, overflow: 'hidden', flexShrink: 0 }}>
                <img src={blog.image} alt={blog.title} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
              </div>
              <div style={{ padding: '18px 20px 22px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded ${categoryColors[blog.category] || 'bg-gray-100 text-gray-600'}`}>{blog.category}</span>
                  <span style={{ fontSize: 11, color: '#9ca3af' }}>{blog.readTime}</span>
                </div>
                <h3 style={{ fontSize: 15, fontWeight: 700, color: '#19354a', lineHeight: 1.4, marginBottom: 8, flex: 1 }}>{blog.title}</h3>
                <p style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.6, marginBottom: 14 }}>
                  {blog.excerpt.length > 110 ? blog.excerpt.slice(0, 110) + '...' : blog.excerpt}
                </p>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#9ca3af', borderTop: '1px solid #f3f4f6', paddingTop: 12 }}>
                  <span>{blog.author}</span>
                  <span>{blog.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {filtered.length === 0 && (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#9ca3af' }}>
            <p style={{ fontSize: 16, fontWeight: 600, color: '#374151', marginBottom: 8 }}>No articles in this category yet</p>
            <p style={{ fontSize: 13 }}>Check back soon or browse all articles</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogListing;